import {
  FormTextField,
  ReadonlyField,
  type FormTextFieldProps,
  type ReadonlyFieldProps,
} from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import type { BaseInputModeProps, BaseViewModeProps } from '../../types';

type InputModeProps = BaseInputModeProps<Omit<FormTextFieldProps<FieldValues>, 'name'>>;

type ViewModeProps = BaseViewModeProps<Omit<ReadonlyFieldProps, 'content'>>;

export type TextFieldRendererProps = InputModeProps | ViewModeProps;

export default function TextFieldRenderer(props: Readonly<TextFieldRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps } = props;
      return <FormTextField name={name} {...slotProps} />;
    }
    case 'view': {
      const { value, slotProps } = props;
      return <ReadonlyField content={value} {...slotProps} />;
    }
  }
}
